/** removes milliseconds from datestamp, for shorter x-axis labels */
function dateStampTrimmer() {
  return this.value.slice(0, -4);
}

export default (data) => {
  return {
    chart: {
      type: "line",
      zoomType: "x",
    },
    title: {
      text: "Stream Profile Report",
    },
    xAxis: {
      type: "category",
      title: {
        text: "Reports (Oldest -> Newest)",
      },
      labels: {
        align: "right",
        rotation: -20,
        formatter: dateStampTrimmer,
      },
    },
    yAxis: {
      title: {
        text: "Stream Profile",
      },
      min:
        data && data.length
          ? Math.min.apply(
              null,
              data.map(function (item) {
                return item.y;
              })
            ) - 1
          : 0,
      max:
        data && data.length
          ? Math.max.apply(
              null,
              data.map(function (item) {
                return item.y;
              })
            ) + 1
          : 5,
    },
    plotOptions: {
      line: {
        dataLabels: {
          enabled: true,
        },
      },
    },
    series: [
      {
        type: "line",
        name: "End Stream",
        data: data,
      },
    ],
  };
};
